import React from 'react';

import { useViewport } from 'contexts/viewport';
import withResponsiveLayout from 'hoc/withResponsive';
import Mobile from 'pages/Login/mobile';
import Tablet from 'pages/Login/tablet';
import Desktop from 'pages/Login/desktop';

const PageLayout = () => {
    const { width } = useViewport();

    const props = {};

    const responsiveLayouts = {
        mobile: <Mobile {...props} />,
        tablet: <Tablet {...props} />,
        desktop: <Desktop {...props} />,
    };

    return <>{withResponsiveLayout(width, responsiveLayouts)}</>;
};

export default PageLayout;
